import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { useNavigate } from 'react-router';
import { showSystemToast } from 'view/components/SystemToast';

export const useResetPassword = (): {
  isLoading: boolean;
  resetPassword: (body: { password: string; hash: string | null }) => void;
} => {
  const navigate = useNavigate();

  const { isLoading, error, status, send } = useRequest({
    url: '/api/v1/auth/reset/password',
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
    body: {},
  });

  const resetPassword = (body: { password: string; hash: string | null }) => {
    const { password, hash } = body;
    if (password && hash) {
      send({ ...body });
    }
  };

  if (!error && status === 204) {
    navigate('/auth/login', { replace: true });
    showSystemToast(
      'success',
      'Password Changed',
      'Please Log In with a new password to continue '
    );
  }

  return { isLoading, resetPassword };
};
